import { useState, useRef, useEffect } from 'react';
import toast from 'react-hot-toast';
import { generateComplianceResponse } from '../services/openaiService';

export const useComplianceChat = () => {
  const [messages, setMessages] = useState([
    {
      type: 'system',
      content: 'Hello! I\'m your Compliance AI assistant. I can help you understand regulatory requirements and compliance standards for expanding into MENAP markets. What would you like to know?'
    }
  ]);
  const [input, setInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    const userMessage = {
      type: 'user',
      content: input
    };

    setMessages(prev => [...prev, userMessage]);
    setInput('');
    setIsLoading(true);

    try {
      const aiResponse = await generateComplianceResponse(
        messages.filter(msg => msg.type !== 'system').concat(userMessage)
      );
      
      setMessages(prev => [...prev, {
        type: 'assistant',
        content: aiResponse
      }]);
    } catch (error) {
      toast.error('Failed to get response. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return {
    messages,
    input,
    setInput,
    isLoading,
    handleSubmit,
    messagesEndRef
  };
};